import router from '@/modules/domains/router'
export default {
  router,
}
